// Mock data & translations for VenaTerra s.r.o. B2B website
// TODO(backend): replace contact form submission with real POST /api/inquiries endpoint

export const COMPANY = {
  name: 'VenaTerra s.r.o.',
  tagline: 'Blood of Logistics',
  ico: '24583791',
  dic: 'CZ24583791',
  address: 'Praha, Česká republika',
  email: 'info@venaterrasro.com',
  phone: '+420 737 164 620',
  phoneRaw: '+420737164620',
  website: 'venaterrasro.com',
  founded: 2026,
  director: {
    name: 'Lusine Martirosyanová',
    email: 'lusine@venaterrasro.com',
    roleEn: 'Managing Director',
    roleCs: 'Jednatelka',
  },
  socials: {
    facebook: 'https://facebook.com/venaterrasro',
    instagram: 'https://instagram.com/venaterrasro',
    linkedin: 'https://linkedin.com/company/venaterra',
  },
};

// Brand logo (planet + VenaTerra wordmark + tagline) — self-hosted for reliability
export const LOGO_URL = '/img/logo.png';

export const IMAGES = {
  // Hero uses the official planet logo (Blood of Logistics visual)
  heroTruck: '/img/logo.png',
  // Branded fleet banner (3 black vehicles) — user-supplied, self-hosted
  fleetBanner: '/img/fleet-banner.png',
  // User-supplied real photos (self-hosted, cache-busted with ?v=2)
  aboutTruck: '/img/about-truck.png?v=2',
  expressTruck: '/img/express-truck.png?v=2',
  ltlTruck: '/img/ltl-truck.png?v=2',
  fleetSunset: '/img/fleet-sunset.png?v=2',
  // Individual black vehicle photos — Pexels, compressed for fast loading
  highway: 'https://images.pexels.com/photos/16100085/pexels-photo-16100085.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  semiTruck: 'https://images.pexels.com/photos/16100083/pexels-photo-16100083.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  fleetLineup: 'https://images.pexels.com/photos/30536324/pexels-photo-30536324.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  sprinterVan: 'https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  cargoVan: 'https://images.pexels.com/photos/18029633/pexels-photo-18029633.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  blackVan: 'https://images.pexels.com/photos/18031901/pexels-photo-18031901.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  // Aliases used across pages
  warehouse: 'https://images.pexels.com/photos/16100083/pexels-photo-16100083.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  loadingDock: 'https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  cargo: 'https://images.pexels.com/photos/16100085/pexels-photo-16100085.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  fleet: 'https://images.pexels.com/photos/30536324/pexels-photo-30536324.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  van: 'https://images.pexels.com/photos/19871522/pexels-photo-19871522.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  sprinter: 'https://images.pexels.com/photos/18029633/pexels-photo-18029633.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
  dispatch: 'https://images.pexels.com/photos/6407553/pexels-photo-6407553.jpeg?auto=compress&cs=tinysrgb&w=1280&q=75',
};

// KPI stats shown on Home & About
export const STATS = [
  { key: 'countries', valueEn: '25+', valueCs: '25+', labelEn: 'Countries served', labelCs: 'Obsluhovaných zemí' },
  { key: 'onTime', valueEn: '99.4%', valueCs: '99,4 %', labelEn: 'On-time delivery', labelCs: 'Přeprav včas' },
  { key: 'response', valueEn: '< 30 min', valueCs: '< 30 min', labelEn: 'Quote response', labelCs: 'Odezva na poptávku' },
  { key: 'fleet', valueEn: 'Euro 6', valueCs: 'Euro 6', labelEn: 'Emission standard', labelCs: 'Emisní norma' },
];

// SEO — page-specific meta (title + description) per language
export const SEO = {
  en: {
    home: {
      title: 'VenaTerra s.r.o. | International Freight, FTL & Express Transport across Europe',
      description: 'Prague-based B2B carrier. Express, FTL, LTL, dedicated and Just-in-Time transport across Europe with CMR-insured cargo, Euro 6 fleet and real-time GPS tracking.',
    },
    services: {
      title: 'Services — Express, FTL, LTL, Dedicated & JIT | VenaTerra s.r.o.',
      description: 'Full range of road freight services: express transport, full truckload (FTL), less-than-truckload (LTL), dedicated deliveries and Automotive Just-in-Time across Europe.',
    },
    fleet: {
      title: 'Fleet & Assurance — Euro 6, CMR-insured, GPS-tracked | VenaTerra s.r.o.',
      description: 'Modern Euro 6 fleet, CMR insurance up to €500,000, 100% GPS tracking and 24/7 dispatch. All parameters procurement teams need to greenlight a carrier.',
    },
    about: {
      title: 'About VenaTerra s.r.o. | Reliable Prague-based B2B carrier',
      description: 'VenaTerra s.r.o. is a Prague-based transport & logistics company led by Lusine Martirosyanová. We keep the industrial bloodstream flowing — a reliable B2B carrier for manufacturers and automotive suppliers.',
    },
    contact: {
      title: 'Request Transport | Contact VenaTerra s.r.o.',
      description: 'Send us your route and cargo details. Non-binding quote within 30 minutes during business hours. E-mail info@venaterrasro.com or call +420 737 164 620.',
    },
  },
  cs: {
    home: {
      title: 'VenaTerra s.r.o. | Mezinárodní kamionová doprava, FTL a expresní přeprava po Evropě',
      description: 'Pražský B2B dopravce. Expresní přeprava, FTL, LTL, dedikované závozy a Just-in-Time logistika po celé Evropě. Pojištění CMR, vozový park Euro 6 a GPS sledování v reálném čase.',
    },
    services: {
      title: 'Služby — Expresní, FTL, LTL, dedikovaná přeprava a JIT | VenaTerra s.r.o.',
      description: 'Kompletní silniční nákladní doprava: expresní přeprava zásilek, celovozová (FTL), kusové zásilky (LTL), dedikované závozy a Automotive Just-in-Time po Evropě.',
    },
    fleet: {
      title: 'Vozový park a záruky — Euro 6, pojištění CMR, GPS | VenaTerra s.r.o.',
      description: 'Moderní vozový park Euro 6, pojištění nákladu CMR do 500 000 €, 100% GPS sledování a non-stop dispečink. Vše, co nákupčí potřebuje k odsouhlasení dopravce.',
    },
    about: {
      title: 'O společnosti VenaTerra s.r.o. | Spolehlivý pražský B2B dopravce',
      description: 'VenaTerra s.r.o. je pražská dopravní a logistická společnost vedená Lusine Martirosyanovou. Zajišťujeme, aby krevní oběh průmyslu proudil bez přerušení — spolehlivý B2B dopravce pro výrobní firmy a automotive dodavatele.',
    },
    contact: {
      title: 'Poptávka přepravy | Kontakt VenaTerra s.r.o.',
      description: 'Pošlete nám trasu a parametry zásilky. Nezávazná cenová nabídka do 30 minut v pracovní době. E-mail info@venaterrasro.com nebo +420 737 164 620.',
    },
  },
};

// Full translation dictionary EN & CS
export const T = {
  en: {
    nav: { home: 'Home', services: 'Services', fleet: 'Fleet & Assurance', about: 'About', contact: 'Contact' },
    cta: { requestQuote: 'Request a Quote', getInTouch: 'Get in Touch', learnMore: 'Learn more' },
    hero: {
      eyebrow: 'International & Domestic Transport',
      title: 'Your Cargo.',
      titleAccent: 'Our Mission.',
      subtitle: 'Palletised freight, tarp vans and full truckloads across Europe for manufacturers and automotive suppliers — with CMR-insured cargo, Euro 6 fleet and real-time GPS tracking.',
      pointA: 'CMR insured up to €500,000',
      pointB: 'Real-time GPS tracking',
      pointC: 'Non-stop dispatch',
    },
    trust: {
      title: 'Built for procurement. Trusted by industry.',
      subtitle: 'Every metric a procurement manager needs to greenlight a carrier — visible in seconds.',
      insurance: { title: 'CMR insurance', desc: 'Cargo insured under the CMR convention up to €500,000 with a top-tier European insurer.' },
      fleet: { title: 'Euro 6 fleet', desc: 'Modern vehicles meeting the strictest EU emission standards — a hard requirement for ESG-audited shippers.' },
      gps: { title: 'GPS tracking', desc: 'Every vehicle monitored 24/7 in real time. Live location and ETA available to key accounts on request.' },
      legal: { title: 'Legal transparency', desc: 'Registered in the Czech Republic. IČO, DIČ and registered office publicly listed for procurement due diligence.' },
    },
    services: {
      eyebrow: 'What we do',
      title: 'Logistics services tailored to manufacturers',
      subtitle: 'From single-pallet express to dedicated Just-in-Time lines for automotive plants.',
      items: [
        { id: 'express', title: 'Express & VIP Delivery', desc: 'Time-critical shipments across Europe with dedicated drivers, guaranteed pickup within 3 hours and door-to-door delivery.', bullets: ['Same-day pickup', 'Two drivers on request', 'Live ETA reporting'] },
        { id: 'ftl', title: 'Full Truckload (FTL)', desc: 'Complete truck capacity dedicated to your cargo. No consolidation stops, no transhipment — direct delivery from A to B.', bullets: ['13.6 m mega trailers', 'Up to 24 t payload', 'ADR available'] },
        { id: 'ltl', title: 'Less than Truckload (LTL)', desc: 'Groupage and part-load shipments across Europe with reliable transit times. Ideal for pallets that do not fill a full truck.', bullets: ['1–15 EUR pallets', 'Weekly fixed lines', 'Consolidated at Prague hub'] },
        { id: 'dedicated', title: 'Dedicated Deliveries', desc: 'Sensitive, high-value or oversized loads handled by a vehicle assigned exclusively to your shipment.', bullets: ['Sealed compartments', 'Security-vetted drivers', 'Sprinter & taillift transport'] },
        { id: 'jit', title: 'Automotive Just-in-Time', desc: 'Regular JIT / JIS lines for automotive tier suppliers. Fixed slot times, penalty-backed SLAs, 15-min delivery windows.', bullets: ['Fixed weekly milk-runs', 'SLA-backed slot times', 'Empty return management'] },
      ],
    },
    fleet: {
      eyebrow: 'Fleet & Assurance',
      title: 'A modern fleet, insured to the highest standards',
      subtitle: 'Own vehicles and a vetted network of long-term partners — all operating to the same quality, safety and insurance standards.',
      specs: [
        { label: 'Emission standard', value: 'Euro 6 exclusively' },
        { label: 'Vehicle types', value: 'Sprinter 3.5 t · Solo 12 t · Truck+trailer 24 t' },
        { label: 'Trailer sizes', value: 'Tautliner, box, taillift' },
        { label: 'Cargo insurance', value: 'CMR up to €500,000' },
        { label: 'GPS & telematics', value: 'Real-time tracking on 100 % of fleet' },
        { label: 'Dispatch coverage', value: 'Non-stop, 365 days a year' },
      ],
    },
    about: {
      eyebrow: 'About VenaTerra',
      title: 'Transport is the bloodstream of industry. We keep it flowing — without interruption.',
      p1: 'VenaTerra was born from the conviction that even a small Czech company can deliver European quality and reliability. We combine a personal approach, the speed of a small team and strict corporate standards — CMR insurance, modern Euro 6 vehicles, 24/7 GPS tracking and full transparency.',
      p2: 'Every load, every pallet, every delivery deadline — we take it personally. Because we know that behind every shipment stands the living business of our customers.',
      pillars: [
        { title: 'Personal accountability', desc: 'A named account manager for every long-term client.' },
        { title: 'Compliance-first', desc: 'CMR, GDPR and ADR documentation delivered on demand.' },
        { title: 'Long-term thinking', desc: 'We build relationships, not one-off loads.' },
      ],
      leadership: 'Leadership',
      leadershipDesc: 'Direct line to management — for the good news and the bad.',
    },
    contact: {
      eyebrow: 'Request Transport',
      title: 'Get in touch',
      subtitle: "Send us the basics of your route and we'll reply with a non-binding quote — usually within 30 minutes during business hours.",
      form: {
        firstName: 'First name', lastName: 'Last name', company: 'Company', email: 'Business email', phone: 'Phone',
        origin: 'Loading location (from)', destination: 'Delivery location (to)',
        cargo: 'Cargo type', weight: 'Weight / dimensions', date: 'Requested pickup date',
        message: 'Additional details', send: 'Send request', sending: 'Sending…',
        successTitle: 'Request received', successMsg: 'Thank you — our dispatch team will reply within 30 minutes on business days.',
        errorTitle: 'Something went wrong', errorMsg: 'Please try again or e-mail us directly at info@venaterrasro.com.',
      },
      info: { emailLabel: 'Email', phoneLabel: 'Dispatch (24/7)', addressLabel: 'Registered office', hoursLabel: 'Business hours', hoursValue: 'Mon–Fri 8:00–18:00 CET · Dispatch 24/7' },
    },
    footer: {
      about: 'International & domestic transport & logistics — express, FTL, LTL and dedicated deliveries with CMR-insured cargo and a Euro 6 fleet.',
      quickLinks: 'Quick links', legal: 'Legal & registration', follow: 'Follow us', rights: 'All rights reserved.',
      privacy: 'Privacy policy', terms: 'Terms of service',
    },
  },
  cs: {
    nav: { home: 'Úvod', services: 'Služby', fleet: 'Vozový park', about: 'O nás', contact: 'Kontakt' },
    cta: { requestQuote: 'Poptat přepravu', getInTouch: 'Kontaktujte nás', learnMore: 'Zjistit více' },
    hero: {
      eyebrow: 'Mezinárodní a tuzemská přeprava',
      title: 'Váš náklad.',
      titleAccent: 'Naše mise.',
      subtitle: 'Paletové přepravy, plachtové dodávky a celokamionové zásilky po celé Evropě pro výrobní firmy a automotive dodavatele — s pojištěním CMR, vozovým parkem Euro 6 a GPS sledováním v reálném čase.',
      pointA: 'Pojištění CMR až do 500 000 €',
      pointB: 'GPS sledování v reálném čase',
      pointC: 'Nepřetržitý dispečink',
    },
    trust: {
      title: 'Připraveno pro nákupčí. Ověřeno v průmyslu.',
      subtitle: 'Všechny údaje, které nákupčí potřebuje k odsouhlasení dopravce — viditelné během několika sekund.',
      insurance: { title: 'Pojištění CMR', desc: 'Náklad pojištěn v rámci úmluvy CMR do výše 500 000 € u renomované evropské pojišťovny.' },
      fleet: { title: 'Vozový park Euro 6', desc: 'Moderní vozidla splňující nejpřísnější emisní normy EU — nezbytný požadavek pro firmy s ESG audity.' },
      gps: { title: 'GPS tracking', desc: 'Každé vozidlo monitorováno 24/7 v reálném čase. Živá poloha a ETA k dispozici klíčovým klientům.' },
      legal: { title: 'Právní transparentnost', desc: 'Sídlo v České republice. IČO, DIČ a adresa veřejně dohledatelné pro účely nákupčího due diligence.' },
    },
    services: {
      eyebrow: 'Co nabízíme',
      title: 'Logistické služby šité na míru výrobcům',
      subtitle: 'Od expresní přepravy jedné palety po dedikované linky Just-in-Time pro automotive závody.',
      items: [
        { id: 'express', title: 'Expresní a VIP přeprava', desc: 'Časově kritické zásilky po celé Evropě s vlastním řidičem, garantovaná nakládka do 3 hodin a doručení dům–dům.', bullets: ['Nakládka ještě týž den', 'Dva řidiči na vyžádání', 'Živé hlášení ETA'] },
        { id: 'ftl', title: 'Celovozové zásilky (FTL)', desc: 'Celá kapacita vozu vyhrazena pro váš náklad. Bez překládek, bez konsolidace — přímé doručení z bodu A do bodu B.', bullets: ['Návěsy 13,6 m', 'Nosnost až 24 t', 'ADR na vyžádání'] },
        { id: 'ltl', title: 'Kusové zásilky (LTL)', desc: 'Sběrná služba a dokládky po celé Evropě se spolehlivými přepravními časy. Ideální pro palety, které nezaplní celý vůz.', bullets: ['1–15 EUR palet', 'Pevné týdenní linky', 'Konsolidace v pražském hubu'] },
        { id: 'dedicated', title: 'Dedikované závozy', desc: 'Citlivé, hodnotné nebo nadrozměrné zásilky s vozem vyhrazeným výhradně pro vás.', bullets: ['Zaplombované prostory', 'Prověření řidiči', 'Sprinter a vozy s hydraulickým čelem'] },
        { id: 'jit', title: 'Automotive Just-in-Time', desc: 'Pravidelné JIT / JIS linky pro automotive dodavatele. Pevné časové okno, SLA s penalizacemi, 15minutová okna doručení.', bullets: ['Pevné týdenní okruhy', 'SLA s pevnými sloty', 'Řízení zpětných jízd'] },
      ],
    },
    fleet: {
      eyebrow: 'Vozový park a záruky',
      title: 'Moderní vozový park s prvotřídním pojištěním',
      subtitle: 'Vlastní vozidla i prověřená síť dlouhodobých partnerů — všichni splňují stejné kvalitativní, bezpečnostní a pojistné standardy.',
      specs: [
        { label: 'Emisní norma', value: 'Výhradně Euro 6' },
        { label: 'Typy vozidel', value: 'Sprinter 3,5 t · Sólo 12 t · Souprava 24 t' },
        { label: 'Návěsy', value: 'Plachta, skříň, hydraulické čelo' },
        { label: 'Pojištění nákladu', value: 'CMR do 500 000 €' },
        { label: 'GPS a telematika', value: 'Sledování v reálném čase u 100 % vozů' },
        { label: 'Dispečink', value: 'Non-stop, 365 dní v roce' },
      ],
    },
    about: {
      eyebrow: 'O společnosti VenaTerra',
      title: 'Doprava je krevním oběhem průmyslu. My zajišťujeme, aby proudila bez přerušení.',
      p1: 'VenaTerra vznikla z přesvědčení, že i malá česká firma může nabízet evropskou kvalitu a spolehlivost. Kombinujeme osobní přístup, rychlost malého týmu a přísné korporátní standardy — pojištění CMR, moderní Euro 6 vozidla, GPS sledování 24/7 a plnou transparentnost.',
      p2: 'Každý náklad, každá paleta, každý termín dodání bereme osobně. Protože víme, že za každou zásilkou stojí živý byznys našich zákazníků.',
      pillars: [
        { title: 'Osobní odpovědnost', desc: 'Konkrétní account manager pro každého dlouhodobého klienta.' },
        { title: 'Compliance na prvním místě', desc: 'CMR, GDPR a ADR dokumentace na vyžádání.' },
        { title: 'Dlouhodobé myšlení', desc: 'Budujeme vztahy, ne jednorázové zakázky.' },
      ],
      leadership: 'Vedení společnosti',
      leadershipDesc: 'Přímá linka na vedení — v dobrém i ve zlém.',
    },
    contact: {
      eyebrow: 'Poptávka přepravy',
      title: 'Napište nám',
      subtitle: 'Pošlete nám základní parametry trasy a my odpovíme s nezávaznou cenovou nabídkou — obvykle do 30 minut v pracovní době.',
      form: {
        firstName: 'Jméno', lastName: 'Příjmení', company: 'Společnost', email: 'Firemní e-mail', phone: 'Telefon',
        origin: 'Místo nakládky (odkud)', destination: 'Místo vykládky (kam)',
        cargo: 'Typ zboží', weight: 'Hmotnost / rozměry', date: 'Požadované datum nakládky',
        message: 'Doplňující informace', send: 'Odeslat poptávku', sending: 'Odesílám…',
        successTitle: 'Poptávka přijata', successMsg: 'Děkujeme — dispečink vám odpoví do 30 minut v pracovní dny.',
        errorTitle: 'Něco se nepovedlo', errorMsg: 'Zkuste to znovu nebo nám napište přímo na info@venaterrasro.com.',
      },
      info: { emailLabel: 'E-mail', phoneLabel: 'Dispečink (24/7)', addressLabel: 'Sídlo společnosti', hoursLabel: 'Provozní doba', hoursValue: 'Po–Pá 8:00–18:00 SEČ · Dispečink 24/7' },
    },
    footer: {
      about: 'Evropská přeprava a logistika — expresní, FTL, LTL a dedikované závozy s pojištěním CMR a vozovým parkem Euro 6.',
      quickLinks: 'Rychlé odkazy', legal: 'Právní údaje', follow: 'Sledujte nás', rights: 'Všechna práva vyhrazena.',
      privacy: 'Ochrana údajů', terms: 'Obchodní podmínky',
    },
  },
};
